module.exports = __webpack_public_path__ + "89ef12c7b21d8ccceca243af67c21c0d.png";